import jQuery from 'jquery';
import { skybetDiffusionName } from '../../helpers/utils';

const BOOKMAKER_LOGO_CLASS = 'RC-oddsHeaderZone__data_logo';
const SELECTED_BOOKMAKER_CLASS = 'RC-oddsHeaderZone__data_active';
const BOOKMAKER_DATA_PROPERTY = 'data-header-bookie';
const BEST_ODDS_CLASS = 'js-RC-oddsRaceContent__data_bestOdds';
const POPOVER_CLASS = 'js-RC-skybet-popover';
const EACH_WAY_CLASS = 'js-RC-oddsRaceContent__data_eachWay';
const CHECKED_CLASS = 'RC-oddsRaceContent__data_checked';
const WIN_ODDS_CLASS = 'js-RC-oddsRaceContent__winOdds';
const PLACE_WINNER_CLASS = 'js-RC-oddsRaceContent__placeWinner';

const classToSelector = cssClass => `.${cssClass}`;
const getElementsByClass = cssClass => document.querySelectorAll(classToSelector(cssClass));

export default class OddsTabHeader {
    constructor({
        onBookMakerChanged
    }) {
        this.selectedBookie = null;
        this.onBookMakerChanged = onBookMakerChanged || (() => {});
        this.selectBookie = this.selectBookie.bind(this);
    }

    get bookiesArray() {
        if (!this.private_bookiesArray) {
            this.private_bookiesArray =
                Array.from(
                    document.querySelectorAll(`[${BOOKMAKER_DATA_PROPERTY}]`)
                )
                    .map(bookieElem => bookieElem.getAttribute(BOOKMAKER_DATA_PROPERTY));
        }
        return this.private_bookiesArray;
    }

    init() {
        jQuery(classToSelector(BOOKMAKER_LOGO_CLASS))
            .click(this.selectBookie);
    }

    getSelectedBookie() {
        return this.selectedBookie;
    }

    updateHeaderUI(data) {
        // needed index in DOM to get right BOG and EW cell
        const bookmakerIndex = this.bookiesArray.indexOf(data.bookmaker);
        const BOGArray = getElementsByClass(BEST_ODDS_CLASS);
        const EWArray = getElementsByClass(EACH_WAY_CLASS);
        const BOGElement = BOGArray[bookmakerIndex];
        const EWElement = EWArray[bookmakerIndex];
        const placeWinnerElem = EWElement.querySelector(classToSelector(PLACE_WINNER_CLASS));
        const winOddsElem = EWElement.querySelector(classToSelector(WIN_ODDS_CLASS));

        winOddsElem.innerHTML = data.isWinOnly ? '<b>win only</b>' : (data.winOdds || '');
        placeWinnerElem.innerHTML = data.isWinOnly ? '' : (data.placeWinner || '');

        const Popover = getElementsByClass(POPOVER_CLASS)[0];
        if (data.isBog === 'Y') {
            BOGElement.classList.add(CHECKED_CLASS);
            if (data.bookmaker === skybetDiffusionName) {
                Popover.classList.remove('hidden-popover');
            }
        } else {
            BOGElement.classList.remove(CHECKED_CLASS);
            if (data.bookmaker === skybetDiffusionName) {
                Popover.classList.add('hidden-popover');
            }
        }
    }

    /**
     * @private
     */
    selectBookie({ target: selectedBookieElem }) {
        const prevSelectedElem = document.querySelector(classToSelector(SELECTED_BOOKMAKER_CLASS));
        this.selectedBookie = selectedBookieElem.getAttribute(BOOKMAKER_DATA_PROPERTY);
        if (prevSelectedElem) {
            prevSelectedElem.classList.remove(SELECTED_BOOKMAKER_CLASS);
        }
        selectedBookieElem.classList.add(SELECTED_BOOKMAKER_CLASS);
        this.onBookMakerChanged(this.selectedBookie);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/oddsTabHandler/OddsTabHeader.js